import styled from 'styled-components';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

export const Title = styled(Typography)`
  ${({ theme: { breakpoints } }) => `
    margin-bottom: 10px;
    color: #003C3B;
    
    ${breakpoints.up('md')} {
      margin-bottom: 20px;
    }
  `}
`;

export const MoreDetailsButton = styled(Button)`
  ${({ theme: { breakpoints } }) => `
      border: 1px solid #003C3B;
      border-radius: 17px !important;
      background-color: #F2F1F0;
      width: 30%;
      height: 34px;
      color: #003C3B;
      font-size: 11px;
      font-weight: 700;
      ${breakpoints.up('md')} {
        
      }
  `}
`;

export const Description = styled(Box)`
  ${({
    theme: {
      palette,
      colors,
      typography: { body1 },
    },
  }) => `
    color: #003C3B;
    font-size: ${body1.fontSize};
    line-height: ${body1.lineHeight};
    display: inline;

    & + ${MoreDetailsButton} {
      color: ${colors.blues.blues1};
      padding: 0;
      margin-top: -2px;
      background-color: transparent;
    }
  `}
`;
